/**
 * 
 * key
 * 
 */


const key = 'bGVhZF9zdWJzdGF0dXM='

export default key 